<template>
  <v-row no-gutters>
    <v-col
      v-for="(item, index) in list"
      :key="index"
      cols="auto"
      class="f-14 sz-primary-grey--text pa-4 pl-0"
      :class="{ 'pl-md-0': index === 0 }"
    >
      <p class="mb-0 font-weight-regular">
        {{ item.relationName }}
      </p>
      <p class="mb-0 font-weight-medium mt-2">
        {{ item.newName }}
      </p>
      <p class="mb-0 font-weight-regular">
        {{ item.age }} {{ item.ageOption === 1 ? 'lat' : 'msc.' }}
      </p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'MembersComponent',
  props: {
    list: {
      required: true,
      type: Array
    }
  }
}
</script>
